import { render, staticRenderFns } from "./interpreting.vue?vue&type=template&id=1e53acc5&scoped=true&"
import script from "./interpreting.vue?vue&type=script&lang=js&"
export * from "./interpreting.vue?vue&type=script&lang=js&"
import style0 from "./interpreting.vue?vue&type=style&index=0&id=1e53acc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53acc5",
  null
  
)

export default component.exports